var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime12Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maquettes-finales",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/time",
    transform: "translate(0.500000, 0.500000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C2.68530498,0 0,2.68562762 0,6 C0,9.31437238 2.68530498,12 6,12 C9.31341582,12 12,9.31373853 12,6 C12,2.68626147 9.31341582,0 6,0 Z M6,1 C8.76115796,1 11,3.23857311 11,6 C11,8.76142689 8.76115796,11 6,11 C3.23761663,11 1,8.76211452 1,6 C1,3.23788548 3.23761663,1 6,1 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,3 C5.74545989,3 5.94960837,3.17687516 5.99194433,3.41012437 L6,3.5 L6,5.764 L8.36947263,7.70386406 C8.55936991,7.85939407 8.60523421,8.12558552 8.49019396,8.33286135 L8.43947851,8.40749691 C8.28394851,8.59739418 8.01775705,8.64325848 7.81048123,8.52821823 L7.73584567,8.47750279 L5.18318652,6.38681936 C5.09042507,6.31084571 5.02884257,6.20478775 5.00792002,6.08866572 L5,6 L5,3.5 C5,3.22385763 5.22385763,3 5.5,3 Z",
    id: "Stroke-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime12Px);
export default __webpack_public_path__ + "static/media/time_12px.bc27360b.svg";
export { ForwardRef as ReactComponent };